export default class InsightAnswerViewModel {
    public isActive: boolean = false;
    public channel: string = '';
    public question: string = '';
    public answer: string = '';
}